import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles';
import { createStyles } from '@material-ui/core/styles';
import { useLoanStore } from '@roc/feature-loans-shared';
import { observer } from 'mobx-react';
import { ExtensionsDashboardShared } from './extensionsDashboardShared';
import { ExtensionsDashboardSharedNew } from './extensionsDashboardSharedNew';
import { CSSProperties } from 'react';

const useStyles = makeStyles(theme => ({
  container: {
    padding: 16,
  },
  dealName: {
    display: 'flex',
    justifyContent: 'center',
  },
}));

export const ExtensionsDashboard = observer(({ loanId, showTitle = true, style }: { loanId: string; showTitle?: boolean; style?: CSSProperties }) => {
  const { loanStore } = useLoanStore();
  const classes = useStyles();

  return (
    <>
      <Grid container direction="column" className={classes.container} style={style}>
        {
          showTitle &&
          <>
            <Grid item className={classes.dealName}>
              <Typography variant="h6" color="textSecondary">
                {loanStore?.loanDetails.dealName}
              </Typography>
            </Grid>
            <Grid item style={{
              paddingLeft: 12
            }}>
              <Typography variant="h4" style={{ paddingBottom: '15px' }}>Extensions</Typography>
            </Grid>
          </>
        }
        <ExtensionsDashboardShared loanId={loanId} />
      </Grid>
    </>
  );
});


export const ExtensionsDashboardNew = observer(({ loanId }: { loanId: string }) => {
  const { loanStore } = useLoanStore();
  const classes = useStyles();

  return (
    <>
      <Grid container direction="column">
        <Grid item>
          <Typography variant="h4" style={{ paddingBottom: '15px' }} gutterBottom>
            Extensions
          </Typography>
        </Grid>
        <ExtensionsDashboardSharedNew loanId={loanId} />
      </Grid>
    </>
  );
});
